import {_mutations} from './mutation-types'
import Vue from 'vue'

export const mutations = {
  [_mutations.SET_COMPONENTS] (state, components) {
    Vue.set(state.components, 'value', components)
  },
  [_mutations.START_LOADING_COMPONENTS] (state) {
    Vue.set(state.components, 'error', null)
    Vue.set(state.components, 'loaded', false)
    Vue.set(state.components, 'loading', true)
  },
  [_mutations.STOP_LOADING_COMPONENTS] (state) {
    Vue.set(state.components, 'loaded', true)
    Vue.set(state.components, 'loading', false)
  },
  [_mutations.SET_ERROR_LOADING_COMPONENTS] (state, error) {
    Vue.set(state.components, 'error', error)
  },
  [_mutations.UPDATE_SELECTED_CRITERIA] (state, criteria) {
    Vue.set(state.componentsFilter, 'selectedCriteria', criteria)
  },
  [_mutations.SET_AVAILABLE_FILTER_CRITERIA] (state, value) {
    Vue.set(state.componentsFilter.availableFilterCriteria, 'loading', false)
    Vue.set(state.componentsFilter.availableFilterCriteria, 'loaded', true)
    Vue.set(state.componentsFilter.availableFilterCriteria, 'value', value)
    Vue.set(state.componentsFilter.availableFilterCriteria, 'error', null)
  },
  [_mutations.SET_ERROR_BUILDING_AVAILABLE_FILTER_CRITERIA] (state, error) {
    Vue.set(state.componentsFilter.availableFilterCriteria, 'loading', false)
    Vue.set(state.componentsFilter.availableFilterCriteria, 'loaded', false)
    Vue.set(state.componentsFilter.availableFilterCriteria, 'value', null)
    Vue.set(state.componentsFilter.availableFilterCriteria, 'error', error)
  },
  [_mutations.RESET_AVAILABLE_FILTER_CRITERIA] (state) {
    Vue.set(state.componentsFilter.availableFilterCriteria, 'loading', true)
    Vue.set(state.componentsFilter.availableFilterCriteria, 'loaded', false)
    Vue.set(state.componentsFilter.availableFilterCriteria, 'value', null)
    Vue.set(state.componentsFilter.availableFilterCriteria, 'error', null)
  }
}
